export default __webpack_public_path__ + "static/media/head02_zh_cn_pc.8b87dfcf.png";